/* eslint-disable react/jsx-props-no-spreading */
import { func, shape } from 'prop-types';
import { Segment } from 'semantic-ui-react';

import ContextMenuHeader from '../ContextMenuHeader';

import Patient from './Patient';

const PatientInfo = props => {
  const { conversation, closeContextMenu } = props;
  const { latestConsult } = conversation;
  const { forPatient } = latestConsult;
  const consultId = latestConsult?.id;
  const patientId = forPatient?.id;

  return (
    <Segment.Group className="context-menu">
      <ContextMenuHeader title="Patient Info" goBack={closeContextMenu} />
      <Segment className="body">
        <div className="patient-info">
          <Patient
            consultId={consultId}
            patientId={patientId}
            sourceType={latestConsult.extraData?.source?.type}
          />
        </div>
      </Segment>
    </Segment.Group>
  );
};

PatientInfo.propTypes = {
  conversation: shape({}).isRequired,
  closeContextMenu: func.isRequired,
};

export default PatientInfo;
